// Third-party
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import Grid from '@mui/material/Grid2';

// Hooks
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { useTasklists } from '../hooks';
import { TotalCard } from '../../../../components';

// Components
import { TotalIconWrapper } from '../../Shared';

const TasklistTotals = () => {
  const { getTotalItems } = useTasklists();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <Grid container spacing={3}>
      {getTotalItems.map((item) => (
        <Grid
          key={item.title}
          size={{
            xs: 12, sm: 6, md: 4, lg: 4,
          }}
        >
          <TotalCard background={item.cardBg} color={item.cardColor}>
            <Box
              {...(isMobile && {
                px: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              })}
            >
              <TotalIconWrapper sx={{
                mx: isMobile ? 0 : 'auto',
                backgroundImage: item.iconBg,
                iconColor: item.cardColor,
              }}
              >
                <SvgIcon component={item.icon} />
              </TotalIconWrapper>
              <Box>
                <Typography variant="h3">{item.value}</Typography>
                <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                  {item.title}
                </Typography>
              </Box>
            </Box>
          </TotalCard>
        </Grid>
      ))}
    </Grid>
  );
};

export {
  TasklistTotals,
};
